var map = document.querySelector('.cards__map');

if (map) {
  var callback = function(targets) {
    if (targets[0].intersectionRatio >= 1) {
      map.classList.add('cards__map--active');
    }
  };

  var options = {
    threshold: 1.0,
  };

  var observer = new IntersectionObserver(callback, options);

  observer.observe(map);
}
